import { render, staticRenderFns } from "./guides.vue?vue&type=template&id=50829752&scoped=true"
import script from "./guides.vue?vue&type=script&lang=js"
export * from "./guides.vue?vue&type=script&lang=js"
import style0 from "./guides.vue?vue&type=style&index=0&id=50829752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50829752",
  null
  
)

export default component.exports